import React from 'react';
import './CollectionAnnouncement.css';
import { Link } from 'react-router-dom';
import Header from '../../../components/common/Header/header';

const announcementData = {
  name: 'Collection Printemps/Été 2026',
  headline: 'Présentation Runway',
  date: '30 mai 2026 - 13:00',
  location: 'Château La Grande Riedera - Chem. De la Riedera 10, 1724 Le Mouret, Suisse',
  description:
    'La première pièce que j’ai terminée ? \nUne veste en tweed récupéré, doublée de soie. En l’enfilant, j’ai senti le poids des derniers mois s’envoler. \nCette collection, c’est ça :\nDes vêtements qui vous permettent d’être vous, sans excuse, sans masque. Des matières brutes transformées en armures douces.\nDes cicatrices brodées en motifs d’or. Parce que même écorché·e, vous êtes assez.\n\nIci, on ne cache pas qui on est. On le porte !\nBienvenue dans mon Jardin Secret.',
  details: []
};

const CollectionAnnouncement = () => {

  return (
    <div className="collection-announcement-container">
      <div className="collection-header">
        <Header />
      </div>

        <main className="announcement-main">
          <section className="announcement-copy">
            <h1>{announcementData.name}</h1>
            <h2>{announcementData.headline}</h2>
            <p>{announcementData.description}</p>

            <div className="announcement-meta">
              <div>
                <strong>Date</strong>
                <p>{announcementData.date}</p>
              </div>
              <div>
                <strong>Lieu</strong>
                <p>{announcementData.location}</p>
              </div>
            </div>

            <div className="announcement-list">
              {announcementData.details.map((detail, index) => (
                <div key={index} className="announcement-list-item">
                  <span className="bullet" />
                  <span>{detail}</span>
                </div>
              ))}
            </div>

            <div className="announcement-actions">
              <Link to="/creations" className="announcement-link">
                Voir les créations actuelles
              </Link>
            </div>
          </section>

          <aside className="announcement-poster-card">
            <div className="poster-image">
                <img src="https://api.delislecouture.com/uploads/jardin_secret-affiche.png" alt="Affiche des créations" />
            </div>
          </aside>
        </main>

      <footer>
        <Link to="/legal-mention">Mentions légales</Link>
        
      </footer>
    </div>
  );
};

export default CollectionAnnouncement;
